import RegisterItemMainActions from './RegisterItemMainActions'
import RegisterItemMainActionsItem from './RegisterItemMainActionsItem'
import RegisterItemMainActionsItemWrapper from './RegisterItemMainActionsItemWrapper'

RegisterItemMainActions.Item = RegisterItemMainActionsItem
RegisterItemMainActions.ItemWrapper = RegisterItemMainActionsItemWrapper

export default RegisterItemMainActions
